<main>
    <div class="container main">
        <form>
            <h1>Cadastro de Produto</h1>
            <div class="row">
                <div class="col">
                    <label id="label-input" for="name">
                        <span>Nome:</span>
                        <input [(ngModel)]="produto.vc_nome" class="input form-control" type="text" name="name" id="name">
                    </label>
                </div>
            </div>
            <div id="buttons">
                <button (click)="cadastrar()" class="btn-sucesso" type="form">Cadastrar</button>
                <button (click)="cancel()" class="btn-cancelar" type="form">Cancelar</button>
            </div>
        </form>
    </div>
</main>